import $jTU4t$intlbreadcrumbsarAEmjs from "../intl/breadcrumbs/ar-AE.mjs";
import $jTU4t$intlbreadcrumbsbgBGmjs from "../intl/breadcrumbs/bg-BG.mjs";
import $jTU4t$intlbreadcrumbscsCZmjs from "../intl/breadcrumbs/cs-CZ.mjs";
import $jTU4t$intlbreadcrumbsdaDKmjs from "../intl/breadcrumbs/da-DK.mjs";
import $jTU4t$intlbreadcrumbsdeDEmjs from "../intl/breadcrumbs/de-DE.mjs";
import $jTU4t$intlbreadcrumbselGRmjs from "../intl/breadcrumbs/el-GR.mjs";
import $jTU4t$intlbreadcrumbsenUSmjs from "../intl/breadcrumbs/en-US.mjs";
import $jTU4t$intlbreadcrumbsesESmjs from "../intl/breadcrumbs/es-ES.mjs";
import $jTU4t$intlbreadcrumbsetEEmjs from "../intl/breadcrumbs/et-EE.mjs";
import $jTU4t$intlbreadcrumbsfiFImjs from "../intl/breadcrumbs/fi-FI.mjs";
import $jTU4t$intlbreadcrumbsfrFRmjs from "../intl/breadcrumbs/fr-FR.mjs";
import $jTU4t$intlbreadcrumbsheILmjs from "../intl/breadcrumbs/he-IL.mjs";
import $jTU4t$intlbreadcrumbshrHRmjs from "../intl/breadcrumbs/hr-HR.mjs";
import $jTU4t$intlbreadcrumbshuHUmjs from "../intl/breadcrumbs/hu-HU.mjs";
import $jTU4t$intlbreadcrumbsitITmjs from "../intl/breadcrumbs/it-IT.mjs";
import $jTU4t$intlbreadcrumbsjaJPmjs from "../intl/breadcrumbs/ja-JP.mjs";
import $jTU4t$intlbreadcrumbskoKRmjs from "../intl/breadcrumbs/ko-KR.mjs";
import $jTU4t$intlbreadcrumbsltLTmjs from "../intl/breadcrumbs/lt-LT.mjs";
import $jTU4t$intlbreadcrumbslvLVmjs from "../intl/breadcrumbs/lv-LV.mjs";
import $jTU4t$intlbreadcrumbsnbNOmjs from "../intl/breadcrumbs/nb-NO.mjs";
import $jTU4t$intlbreadcrumbsnlNLmjs from "../intl/breadcrumbs/nl-NL.mjs";
import $jTU4t$intlbreadcrumbsplPLmjs from "../intl/breadcrumbs/pl-PL.mjs";
import $jTU4t$intlbreadcrumbsptBRmjs from "../intl/breadcrumbs/pt-BR.mjs";
import $jTU4t$intlbreadcrumbsptPTmjs from "../intl/breadcrumbs/pt-PT.mjs";
import $jTU4t$intlbreadcrumbsroROmjs from "../intl/breadcrumbs/ro-RO.mjs";
import $jTU4t$intlbreadcrumbsruRUmjs from "../intl/breadcrumbs/ru-RU.mjs";
import $jTU4t$intlbreadcrumbsskSKmjs from "../intl/breadcrumbs/sk-SK.mjs";
import $jTU4t$intlbreadcrumbsslSImjs from "../intl/breadcrumbs/sl-SI.mjs";
import $jTU4t$intlbreadcrumbssrSPmjs from "../intl/breadcrumbs/sr-SP.mjs";
import $jTU4t$intlbreadcrumbssvSEmjs from "../intl/breadcrumbs/sv-SE.mjs";
import $jTU4t$intlbreadcrumbstrTRmjs from "../intl/breadcrumbs/tr-TR.mjs";
import $jTU4t$intlbreadcrumbsukUAmjs from "../intl/breadcrumbs/uk-UA.mjs";
import $jTU4t$intlbreadcrumbszhCNmjs from "../intl/breadcrumbs/zh-CN.mjs";
import $jTU4t$intlbreadcrumbszhTWmjs from "../intl/breadcrumbs/zh-TW.mjs";

var $fd96f54c158931cf$exports = {};


































$fd96f54c158931cf$exports = {
    "ar-AE": $jTU4t$intlbreadcrumbsarAEmjs,
    "bg-BG": $jTU4t$intlbreadcrumbsbgBGmjs,
    "cs-CZ": $jTU4t$intlbreadcrumbscsCZmjs,
    "da-DK": $jTU4t$intlbreadcrumbsdaDKmjs,
    "de-DE": $jTU4t$intlbreadcrumbsdeDEmjs,
    "el-GR": $jTU4t$intlbreadcrumbselGRmjs,
    "en-US": $jTU4t$intlbreadcrumbsenUSmjs,
    "es-ES": $jTU4t$intlbreadcrumbsesESmjs,
    "et-EE": $jTU4t$intlbreadcrumbsetEEmjs,
    "fi-FI": $jTU4t$intlbreadcrumbsfiFImjs,
    "fr-FR": $jTU4t$intlbreadcrumbsfrFRmjs,
    "he-IL": $jTU4t$intlbreadcrumbsheILmjs,
    "hr-HR": $jTU4t$intlbreadcrumbshrHRmjs,
    "hu-HU": $jTU4t$intlbreadcrumbshuHUmjs,
    "it-IT": $jTU4t$intlbreadcrumbsitITmjs,
    "ja-JP": $jTU4t$intlbreadcrumbsjaJPmjs,
    "ko-KR": $jTU4t$intlbreadcrumbskoKRmjs,
    "lt-LT": $jTU4t$intlbreadcrumbsltLTmjs,
    "lv-LV": $jTU4t$intlbreadcrumbslvLVmjs,
    "nb-NO": $jTU4t$intlbreadcrumbsnbNOmjs,
    "nl-NL": $jTU4t$intlbreadcrumbsnlNLmjs,
    "pl-PL": $jTU4t$intlbreadcrumbsplPLmjs,
    "pt-BR": $jTU4t$intlbreadcrumbsptBRmjs,
    "pt-PT": $jTU4t$intlbreadcrumbsptPTmjs,
    "ro-RO": $jTU4t$intlbreadcrumbsroROmjs,
    "ru-RU": $jTU4t$intlbreadcrumbsruRUmjs,
    "sk-SK": $jTU4t$intlbreadcrumbsskSKmjs,
    "sl-SI": $jTU4t$intlbreadcrumbsslSImjs,
    "sr-SP": $jTU4t$intlbreadcrumbssrSPmjs,
    "sv-SE": $jTU4t$intlbreadcrumbssvSEmjs,
    "tr-TR": $jTU4t$intlbreadcrumbstrTRmjs,
    "uk-UA": $jTU4t$intlbreadcrumbsukUAmjs,
    "zh-CN": $jTU4t$intlbreadcrumbszhCNmjs,
    "zh-TW": $jTU4t$intlbreadcrumbszhTWmjs
};


export {$fd96f54c158931cf$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
